import React, { useEffect } from 'react';
import './WelcomePage.scss';

import { Icon } from '../../atoms/Icon/Icon';
import { StepBarContent } from '../StepBar/StepBar';
import { trackEvent, SectionLoaded } from '../../../utils/mixpanel';
import homeImg from '../../../assets/images/home.svg';

export const WelcomePage = (props) => {
  const { onContinue, onBrokerContinue } = props;

  useEffect(() => {
    trackEvent(SectionLoaded('Welcome Page'))
  }, [])
  
  return (
    <div className='welcome-page'>
      <div className='left-column'>
        <div className='content'>
          <div className='welcome'>
            <h1>Price your loan with Constitution Lending!</h1>
            <p>We’re going to ask you a few questions to get you the most accurate term sheet. If you don’t know something, just estimate. Also, please note, we only do loans for investment properties.</p>
          </div>

          <div className='rate' onClick={onContinue}>
            Give me my rate!
          </div>

          <div className='broker' onClick={onBrokerContinue}>
            <span>
              {"I’m a broker -->"}
            </span>
          </div>

          <p className='account'>
            Already have an account? <span onClick={() => { window.location.href = `${process.env.REACT_APP_BORROWER_DASHBOARD_URL}` }}>Sign in</span>
          </p>
        </div>
      </div>
      <div className="right">
          <div className="content">
            <div>
              <img className="star" src="https://storage.googleapis.com/constlending-borrowers/static/star-vector.svg" />
            </div>
            <p className="phrase">
            &quot;Dealing with multiple lenders is SO exhausting and wondering if I&apos;d get financing made me apprehensive about chasing deals. Thanks to you, I can just focus on buying properties!&quot;
            </p>
            <div className="author">
              <b>Chandra M</b>
              <br></br>
              Real estate investor
            </div>
          </div>
          <div>
          <img className="home" src={homeImg} />
          </div>
        </div>
    </div>
  );
}